import { useEffect, useState } from "react";

import {
    Box,
    Button,
    Collapse,
    useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { GridFooter, GridFooterContainer } from "@mui/x-data-grid";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import _ from 'lodash'

import FForm, { useFormApi } from "..";
import FormRow from "../FormRow";
import DataTable from "components/DataTable";
import WindowDialog from "components/dialog/WindowDialog";
import TextInput from "../input/TextInput";
import SubmitButton from "../SubmitButton";
import FormContent from "../FormContent";
import { theme } from "AppPersonalise";
import { filterList } from "../../DataFilter/filter";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { red, green } from "@mui/material/colors";

export default function EntitySearchDialog({ checkboxSelection, columns, data, hideFilterColumns, defaultFilters, buttonNewLabel, buttonNew, ...props }) {
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const form = useFormApi();
    const [filters, setFilters] = useState();
    const [results, setResults] = useState([]);
    const [showFilterForm, setShowFilterForm] = useState(false);

    // const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down('sm'))
    const mobileWidth = window.innerWidth <= 768 // 768 é um valor de referência para a largura de dispositivo móvel
    const isMobile = window.cordova || mobileWidth || mobile

    useEffect(() => {
        let newArray = filterList(data, filters)

        setResults(newArray);
    }, [columns, data, filters]);

    useEffect(() => {
        if (defaultFilters) {
            let f = {}
            for (const key in defaultFilters) {
                if (Object.hasOwnProperty.call(defaultFilters, key)) {
                    const element = defaultFilters[key];
                    f[key] = { value: element }

                }
            }
            setFilters(f)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultFilters])

    function handleFilter(values) {
        const newFilters = {};

        // eslint-disable-next-line array-callback-return
        columns.map((column) => {
            if (column.filter) {



                let v = _.get(values, column.field)
                if (v) {
                    newFilters[column.field] = { value: v };
                }

            }
        })


        setFilters(newFilters);
    }

    function toggleFilterForm() {
        setShowFilterForm(!showFilterForm);
    }

    useEffect(() => {
        setShowFilterForm(!fullScreen);
    }, [fullScreen]);

    const dataGridStyles = {
        ...(checkboxSelection ? {} : {
            "& .MuiDataGrid-row:hover": {
                cursor: "pointer",
            },
        }),
    }

    return (
        <WindowDialog
            contentProps={{ sx: { p: { xs: 0, sm: 3 } } }}
            maxWidth={"80%"}
            {...props}
        >
            {(dialogProps) => (
                <Box
                    sx={{ display: "flex", flex: 1, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 0, sm: 2 } }}
                >
                    <Box className="filters" sx={{ maxWidth: { xs: "100%", sm: 200 }, p: { xs: 2, sm: 0 } }}>
                        <FForm formApi={form} onSubmit={handleFilter} initialValues={defaultFilters} contentProps={{ sx: { gap: showFilterForm ? 2 : 0 } }}>
                            <FormRow sx={{ flexDirection: "row-reverse", justifyContent: "space-between" }}>
                                <SubmitButton startIcon={<SearchIcon />} size="small">
                                    Buscar
                                </SubmitButton>

                                <Button
                                    onClick={toggleFilterForm}
                                    variant="contained"
                                    size="small"
                                    endIcon={showFilterForm ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                    sx={{ display: fullScreen ? "flex" : "none" }}
                                >
                                    Filtros
                                </Button>
                            </FormRow>

                            <Collapse in={showFilterForm}>
                                <FormContent>
                                    {columns.map((column) => {
                                        if (column.filter) {
                                            if (hideFilterColumns && hideFilterColumns.includes(column.field)) {
                                                return null;
                                            }
                                            return (
                                                <FormRow key={column.field}>
                                                    <TextInput name={column.field} label={column.headerName} />
                                                </FormRow>
                                            );
                                        } else {
                                            return null;
                                        }
                                    })}
                                </FormContent>
                            </Collapse>


                            {buttonNew &&
                                <>
                                    <Button onClick={() => props.setOpen(true)}>
                                        {buttonNewLabel}
                                    </Button>

                                    {props.open &&
                                        <WindowDialog
                                            title={buttonNewLabel}
                                            onClose={() => {
                                                props.setOpen(false)
                                            }}
                                            open={props.open}
                                        >
                                            {() => {
                                                return (
                                                    (props.children)
                                                )
                                            }}
                                        </WindowDialog>
                                    }
                                </>
                            }

                        </FForm>
                    </Box>
                    <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
                        <DataTable
                            idField="uid"
                            columns={hideFilterColumns ? columns.filter(c => !hideFilterColumns.includes(c.field)) : columns}
                            rows={results}
                            checkboxSelection={checkboxSelection}
                            onRowClick={checkboxSelection ? () => { } : (row) => dialogProps.onClose(row.row)}
                            sx={dataGridStyles}
                            isMobile={isMobile}
                            autoPageSize={isMobile ? true : false}
                            components={{
                                Footer: () =>
                                (
                                    <GridFooterContainer sx={{ display: "flex" }}>
                                        {checkboxSelection &&
                                            <Button
                                                onClick={(rows) => {
                                                    dialogProps.onClose(true)
                                                    handleFilter({})
                                                }}
                                                variant="contained"
                                                sx={{ marginX: 1, flex: 1 }}
                                            >
                                                {isMobile ? <CheckCircle sx={{  color: green[500]  }} /> : 'Confirmar'}
                                            </Button>
                                        }
                                        <Button
                                            onClick={() => dialogProps.onClose(false)}
                                            variant="contained"
                                            sx={{ marginX: 1, flex: 1 }}
                                        >
                                            {isMobile ? <Cancel sx={{ color: red[500] }} /> : 'Cancelar'}
                                        </Button>
                                        <GridFooter />
                                    </GridFooterContainer>
                                )
                            }}
                            {...props}
                        />
                    </Box>
                </Box>
            )}
        </WindowDialog>
    );
}
